import axios from '@/utils/axios';
import {getEnv} from '@/config/environment';

const brandIntegrationUpdaters = {
  linkShopify: async ({
    shopName,
    successRedirectUrl,
    merchantId,
  }: {
    shopName: string;
    successRedirectUrl: string;
    merchantId: string;
  }) =>
    axios.post('/shopify/authenticate', {
      shop_name: shopName,
      success_redirect_url: successRedirectUrl,
      merchant_id: merchantId,
    }),

  unlinkShopify: async ({merchantId}: {merchantId: string}) =>
    axios.post('/shopify/unlink', {merchant_id: merchantId}),

  unlinkInstagram: async ({brandId}: {brandId: string}) =>
    axios.post('/brand_instagram_business_account/unlink', {
      brand_id: brandId,
    }),

  unlinkTiktok: async ({brandId}: {brandId: string}) =>
    axios.post('/tiktok/unlink_business_account', {brand_id: brandId}),
};

/**
 * Instagram OAuth — matches Ember's instagram.js service getAuthUrl()
 * Uses Facebook dialog/oauth with server callback URI pattern
 */
export function buildInstagramOAuthUrl(
  brandId: string,
  partnershipAdsEnabled = false
): string {
  const env = getEnv();
  const appId = env.VITE_FACEBOOK_APP_ID;
  const serverCallbackUri = env.VITE_META_SERVER_CALLBACK_URI;
  const baseScopes = [
    'business_management',
    'instagram_branded_content_ads_brand',
    'pages_show_list',
    'instagram_basic',
  ];
  const partnershipAdsScopes = [
    'ads_management',
    'pages_manage_ads',
    'pages_read_engagement',
  ];
  const scopes = (
    partnershipAdsEnabled
      ? [...baseScopes, ...partnershipAdsScopes]
      : baseScopes
  ).join(',');
  const redirectUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?brandId=${brandId}`;
  const state = JSON.stringify({
    brand_id: brandId,
    failure_redirect_url: redirectUrl,
    network: 'brand_instagram',
    redirect_uri: serverCallbackUri,
    redirect_url: redirectUrl,
  });

  return [
    'https://www.facebook.com/dialog/oauth',
    `?client_id=${appId}`,
    '&display=page',
    `&redirect_uri=${encodeURIComponent(serverCallbackUri)}`,
    '&response_type=code,granted_scopes',
    `&scope=${scopes}`,
    `&state=${encodeURIComponent(state)}`,
  ].join('');
}

/**
 * TikTok OAuth — matches Ember's tiktok-creator-marketplace.js service authenticate()
 */
export function buildTiktokOAuthUrl(brandId: string): string {
  const env = getEnv();
  const appId = env.VITE_TIKTOK_APP_ID;
  const redirectUrl = encodeURIComponent(env.VITE_TIKTOK_REDIRECT_URL);
  const rid = env.VITE_TIKTOK_AUTH_URL_RID;

  return `https://ads.tiktok.com/marketing_api/auth?app_id=${appId}&state=${brandId}&redirect_uri=${redirectUrl}&rid=${rid}`;
}

export default brandIntegrationUpdaters;
